// extracted by mini-css-extract-plugin
module.exports = {"BooksPaymentMethods":"BooksPaymentMethods_BooksPaymentMethods__2yvyj"};